import React from "react";
import { TextOqt, TextPropertyName, WrapperComponent } from "../..";

export const FormNodeStart = ({fmk}) => {
  return (
    <>
      <WrapperComponent caption="Nombre" Field={<TextPropertyName autoFocus name="nombre" formik={fmk} variant="standard"/>}/>
      <WrapperComponent caption="Descripción" Field={<TextOqt name="descripcion" formik={fmk} variant="standard" multiline={true}/>}/>
    </>
  )
}